import { render, staticRenderFns } from "./modifyinquiry.vue?vue&type=template&id=137947de&scoped=true&"
import script from "./modifyinquiry.vue?vue&type=script&lang=js&"
export * from "./modifyinquiry.vue?vue&type=script&lang=js&"
import style0 from "./modifyinquiry.vue?vue&type=style&index=0&id=137947de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137947de",
  null
  
)

export default component.exports